__turbopack_context__.v({
  "checkbox": "AgreeToTermsCheckBox-module-scss-module__LmLgZq__checkbox",
  "container": "AgreeToTermsCheckBox-module-scss-module__LmLgZq__container",
});
